<template>
	<div
		class="settings-column"
		:class="[`size-${size}`]"
	>
		<div
			v-if="showHeader"
			class="header"
		>
			<slot
				name="title"
				:title="title"
				:subtitle="subtitle"
			>
				<div
					v-if="title"
					class="settings-column--title"
				>
					<h2>{{ title }}</h2>
					<p
						v-if="subtitle"
						class="settings-column--subtitle"
					>
						{{ subtitle }}
					</p>
				</div>
			</slot>
			<div
				v-if="closable"
				class="close-btn"
			>
				<Icon
					icon-name="e-remove"
					@click="$emit('close')"
				/>
			</div>
		</div>
		<div class="body">
			<slot name="body" />
		</div>
		<div
			v-if="$slots.footer"
			class="footer"
		>
			<slot name="footer" />
		</div>
		<div
			v-if="disabled"
			class="disable-overlay"
		>
			<p
				class="toast"
				:class="toastClass"
			>
				{{ disabledMessage }}.
			</p>
		</div>
	</div>
</template>

<script>
export default {
	name:  'BaseColumn',
	props: {
		size: {
			type:    Number,
			default: 1,
		},
		title: {
			type:    String,
			default: null,
		},
		subtitle: {
			type:    String,
			default: null,
		},
		closable: {
			type:    Boolean,
			default: false,
		},
		showHeader: {
			type:    Boolean,
			default: true,
		},
		disabled: {
			type: Boolean,
		},
		disabledMessage: {
			type: String,
		},
		toastClass: {
			type:    String,
			default: 'info',
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import '@videotools/sass/fonts';

.settings-column {
	border-right: 1px solid var(--color-grey-800);
	display: flex;
	flex-direction: column;
	position: relative;

	&--title {
		p {
			@include text-sm-2;
			padding-top: 16px;
			color: var(--color-grey-300);
		}
	}
}

.size-1 {
	flex-shrink: 1;
	flex-basis: 33.33%;
}

.size-2 {
	flex-grow: 1;
	flex-basis: 60%;
}

.header {
	display: flex;
	align-items: flex-start;
	padding: 24px 24px 32px 24px;
}

.body {
	display: flex;
	flex-direction: column;
	flex: 1;
	min-height: 0;
	padding: 0 24px;
	overflow-y: auto;
}

.footer {
	align-self: flex-end;
	padding: 24px;
	flex: 0;
	width: 100%;

	.button-group {
		display: flex;
		justify-content: flex-end;

		:not(:last-child) {
			margin-right: 16px;
		}
	}
}

.close-btn {
	cursor: pointer;
}

/* Overlay */
.disable-overlay {
	position: absolute;
	top: 0;
	left: 0;
	background: rgba(31, 32, 37, 0.6);
	width: 100%;
	height: 100%;

	.toast {
		padding: 16px 24px;
		position: absolute;
		top: 0;
		left: 0;
		display: flex;
		align-items: center;
		width: 100%;
		min-height: 80px;
		color: var(--color-white);

		&.warning {
			background: var(--color-red);
		}

		&.info {
			background: var(--color-green-petrol);
		}
	}
}

</style>
